module.exports = __webpack_public_path__ + "static/img/bg-en.40bbb0a1.png";